<template>
  <div>
      <div v-if="isMobileS">
        <div class="notice">
            <div class="title">
                <img :src="Icon1" class="icon"/>
                <span class="notice-font">投稿须知</span>
                <span class="more" @click="goDown">{{ unfoldText }}
                    <img :src="isHideDescFlag?down:Up" />
                </span>
            </div>
            <p v-if="isHideDescFlag">
              参赛作品须为原创作品，严禁抄袭、剽窃他人作品。如有侵权行为，将取消参赛资格并追究法律责任。参赛者需保证所提交的作品不侵犯任何第三方的合法权益，包括但不限于肖像权、著作权等。如有侵权纠纷，由参赛者自行承担法律责任。上传作品需提供原照片。组委会有权对参赛作品进行公益性宣传、展览等活动，不再另付稿酬。作者投稿参赛即视为同意上述事项，不再另行沟通。本大赛最终解释权归组委会所有。
              <span style="display: block;margin-top:10px">参赛作品仅限照片，照片尺寸不低于2M</span>
              </p>
        </div>
        <div class="add-form">
            <div class="formItem">
                <span class="name">稿件类型</span>
                <div class="radio-box" v-for="(item) in types" :key="item.id">
                    <span class="radio" :class="{'on':manuscriptTypeId==item.id}"></span>
                    <input v-model="manuscriptTypeId" :value="item.id" class="input-radio" :checked='manuscriptTypeId==item.id'   @click="selectType(item)" type="radio">
                    <label :class="{'active':manuscriptTypeId==item.id}">{{item.name}}</label>
                </div>
            </div>
            <div class="formItem">
                <h3>填写个人信息</h3>
                <div class="input-box">
                    <span class="name-label">请输入作者：</span>
                    <input @input="handleInput" type="text" placeholder="" class="input" v-model="contributor" ref="contributor"/>
                </div>
                <div class="input-box">
                    <span class="name-label">联系方式：</span>
                    <input @input="handleInput" type="text" placeholder="" class="input" v-model="contact" ref="contact"/>
                </div>
                <div class="input-box">
                    <span class="name-label">征集渠道：</span>
                    <div class="radio-boxs">
                      <div class="radio-box" v-for="(item,index) in channel" :key="item.id">
                          <span class="radio" :class="{'on':item.isChecked}"></span>
                          <input v-model="channelValue" ref="channelValue" :value="item.value" class="input-radio" :checked='item.isChecked'   @click="checkChannel(index,channelValue,channel)"  type="radio">
                          <label>{{item.label}}</label>
                      </div>
                    </div>
                </div>
                <div class="input-box">
                    <span class="name-label">ID：</span>
                    <input type="text" placeholder="" class="input" @input="handleInput" v-model="channelId" ref="channelId"/>
                </div>
            </div>
            <div class="formItem">
                <h3>上传作品</h3>
                <div class="input-box">
                    <span class="name-label">作品名称：</span>
                    <input @input="handleInput" type="text" placeholder="" class="input" ref="title" v-model="title"/>
                </div>
                <div class="input-box" v-if="radioValue == 'image'">
                    <span class="name-label">图片：</span>
                    <div>
                      <div class="uploadList">
                          <van-uploader :after-read="onFileChange" :before-read="beforeFile" v-model="image" multiple :before-delete="deleteFile"/>
                      </div>
                      <div class="hint">图片不超过10M</div>
                    </div>
                </div>
                <div class="input-box other" v-if="radioValue == 'video'">
                    <span class="name-label">视频：</span>
                    <div class="uploadList">
                      <div class="file-upload">
                        <input type="file" id="fileUpload" accept="video/*" @change="appOnVideoChange" style="display: none;" />
                        <label for="fileUpload" class="upload-button">{{ loading ? '上传中...' : '上传视频' }}</label>
                        <span class="hint">视频不超过300M</span>
                        <div id="file-info" v-if="video &&video.length>0" >
                          <div v-for="(item,index) in video" :key="index" class="file-item">
                              <span class="fileName" >
                                  {{item.original}}
                              </span>
                              <span id="deleteFile" @click="h5deleteVideo(item,index)">X</span>
                          </div>
                        </div>
                      </div>
                        <!-- <van-uploader :accept="'video/*'" :after-read="onVideoChange" :before-read="beforeVideo" v-model="video" multiple :before-delete="deleteVideo"/> -->
                    </div>
                </div>
                <div class="input-box other">
                    <span class="name-label">网盘链接：</span>
                    <input type="text" placeholder="" class="input" v-model="link"/>
                </div>
            </div>
            <div class="submit" @click="submit">
                <img :src="SubmitBg"/>
            </div>
            <van-popup v-model="showTip">
                <img :src="WarningIcon" class="icon" @click="showTip = false"/>
                <h2>{{ waringInform }}</h2>
                <p>您可在下方填写网盘链接代替作品上传</p>
                <!-- <p>如您的发布渠道为视频号，可在下方填写网盘链接代替作品上传</p> -->
                <div class="btnModel" @click="showTip = false">我知道了</div>
            </van-popup>
        </div>
      </div>

        <div v-else class="pc">
          <div class="add-pcForm">
              <div class="formItem">
                <span class="name">稿件类型</span>
                <div class="radio-box" v-for="(item) in types" :key="item.id" @click="selectType(item)" >
                    <span class="radio" :class="{'on':manuscriptTypeId==item.id}"></span>
                    <input v-model="manuscriptTypeId" :value="item.id" class="input-radio" :checked='manuscriptTypeId==item.id'   type="radio">
                    <label :class="{'active':manuscriptTypeId==item.id}">{{item.name}}</label>
                </div>
              </div>
              <div class="formItem">
                <h3>填写个人信息</h3>
                <div class="item-box">
                    <div class="input-box" style="width:500px">
                          <span class="name-label">请输入作者：</span>
                          <input @input="handleInput" type="text" placeholder="" class="input" v-model="contributor" ref="contributor"/>
                    </div>
                </div>
                <div class="item-box">
                  <div class="input-box" >
                        <span class="name-label">联系方式：</span>
                        <input @input="handleInput" type="text" placeholder="" class="input" v-model="contact" ref="contact"/>
                    </div>
                </div>
                <div class="item-box">
                  <div class="input-box" style="width:500px;">
                      <span class="name-label">征集渠道：</span>
                      <div class="radio-box" v-for="(item,index) in channel" :key="item.id">
                          <span class="radio" :class="{'on':item.isChecked}"></span>
                          <input v-model="channelValue" ref="channelValue" :value="item.value" class="input-radio" :checked='item.isChecked'   @click="checkChannel(index,channelValue,channel)"  type="radio">
                          <label :class="{'active':item.isChecked}">{{item.label}}</label>
                      </div>
                  </div>
                </div>
                <div class="item-box">
                  <div class="input-box" style="margin-bottom:0">
                      <span class="name-label">ID：</span>
                      <input type="text" placeholder="" class="input" @input="handleInput" v-model="channelId" ref="channelId"/>
                  </div>
                </div>
              </div>
              <div class="formItem">
                <h3>上传作品</h3>
                <div class="input-box">
                    <span class="name-label">作品名称：</span>
                    <input @input="handleInput" type="text" placeholder="" class="input" ref="title" v-model="title"/>
                </div>
                <div class="input-box" v-if="radioValue == 'image'">
                    <span class="name-label">图片：</span>
                    <div class="uploadList">
                        <van-uploader  :after-read="onFileChange" :before-read="beforeFile" v-model="image" multiple :before-delete="deleteFile"/>
                        <span class="hint">图片不超过10M</span>
                      </div>
                </div>
                <div class="input-box other" v-if="radioValue == 'video'">
                    <span class="name-label">视频：</span>
                    <div class="uploadList">
                        <van-uploader :accept="'video/*'" :after-read="onVideoChange" :before-read="beforeVideo" v-model="video" multiple :before-delete="deleteVideo"/>
                        <span class="hint">视频不超过300M</span>
                      </div>
                </div>
                <div class="input-box other nowidth">
                    <span class="name-label">网盘链接：</span>
                    <input type="text" placeholder="" class="input" v-model="link" style="width:350px"/>
                </div>
              </div>
              <div class="submit" @click="submit">
                <img :src="isMobileS?SubmitBg:PcSubmit"/>
              </div>
              <van-popup v-model="showTip">
                <img :src="PcWarningIcon" class="icon" @click="showTip = false"/>
                <h2>{{ waringInform }}</h2>
                <p>您可在下方填写网盘链接代替作品上传</p>
                <!-- <p>如您的发布渠道为视频号，可在下方填写网盘链接代替作品上传</p> -->
                <div class="btnModel" @click="showTip = false">我知道了</div>
              </van-popup>
          </div>
          <div class="pc-noice">
            <span class="addIcon">投稿须知</span>
            <!-- <img :src="PcNoticeIcon" class="icon" /> -->
            <p>参赛作品须为原创作品，严禁抄袭、剽窃他人作品。如有侵权行为，将取消参赛资格并追究法律责任。参赛者需保证所提交的作品不侵犯任何第三方的合法权益，包括但不限于肖像权、著作权等。如有侵权纠纷，由参赛者自行承担法律责任。上传作品需提供原照片。组委会有权对参赛作品进行公益性宣传、展览等活动，不再另付稿酬。作者投稿参赛即视为同意上述事项，不再另行沟通。本大赛最终解释权归组委会所有。
              <span style="display: block;margin-top:20px">参赛作品仅限照片，照片尺寸不低于2M</span>
            </p>
          </div>
        </div>
  </div>
</template>
<script>

import Icon1 from '@/assets/images/icon-1.png'
import down from '@/assets/images/down.png'
import Up from '@/assets/images/up.png'
import SubmitBg from '@/assets/images/submit.png'
import WarningIcon from '@/assets/images/warning.png'
import PcNoticeIcon from '@/assets/images/pc-notice-icon.png'
import PcSubmit from '@/assets/images/pc-submit.png'
import PcWarningIcon from '@/assets/images/pc-warning.png'
import { getActivityInfo, savefile } from '@/api/activity'
// eslint-disable-next-line camelcase
import { intfc_prefix_common } from '@/core/api.config'
import { Toast } from 'vant'

export default {
  name: 'AddForm',
  components: {
  },
  props: {
    isMobileS: {
      type: Boolean
    }
  },
  data () {
    return {
      radio: '1',
      PcSubmit,
      loading: false,
      waringInform: '您的作品上传失败',
      PcWarningIcon,
      Icon1,
      down,
      SubmitBg,
      PcNoticeIcon,
      Up,
      WarningIcon,
      unfoldText: '收起',
      isHideDescFlag: true,
      radioValue: '',
      channelValue: 'douyin',
      fileList: [],
      activityId: '',
      showTip: false,
      radiosType: [
        {
          label: '视频',
          value: 'video',
          isChecked: false
        },
        {
          label: '图片',
          value: 'image',
          isChecked: true
        }
      ],
      channel: [
        {
          label: '抖音',
          value: 'douyin',
          isChecked: true
        },
        {
          label: '小红书',
          value: 'redbook',
          isChecked: false
        },
        {
          label: '视频号',
          value: 'videoChannel',
          isChecked: false
        }
      ],
      types: [],
      typeId: '',
      updateStatusVideo: '',
      weight: '0',
      manuscriptTypeId: '',
      categories: '',
      categoryId: '',
      image: [],
      realyImage: [],
      link: '',
      video: [], // 传接口id
      videoImage: [],
      realyVideo: [],
      title: '', // 作品名称
      contact: '', // 联系方式
      selectedFile: null,
      contributor: '', // 作者
      channelId: '' // ID
    }
  },
  async created () {
    this.activityId = this.$route.query.activityId
    const res = await getActivityInfo({
      activityId: this.activityId
    })
    if (res.code === 0) {
      this.types = res.data.types
      this.typeId = this.types && this.types[0].id
      this.categories = res.data.categories
      this.categoryId = this.categories && this.categories[0].id
      // eslint-disable-next-line array-callback-return
      this.types && this.types.map((item) => {
        if (item.name.indexOf('图片') > -1) {
          this.radioValue = 'image'
          this.manuscriptTypeId = item.id
        } else {
          this.radioValue = 'video'
        }
      })
    }
  },
  methods: {
    h5deleteVideo (item, index) {
      // eslint-disable-next-line array-callback-return
      this.video && this.video.map((ik, idx) => {
        if (item.original === ik.original) {
          this.video.splice(idx, 1)
          this.realyVideo.splice(idx, 1)
        }
      })
      // this.video.splice(index, 1)
      console.log(item, index, this.video, 'dddd')
    },
    appOnVideoChange (event) {
      console.log('dddddd')
      this.loading = true
      const input = event.target
      if ('files' in input && input.files.length > 0) {
        const files = input.files[0]
        if (files.size > 300 * 1024 * 1024) {
          Toast('请上传小于 300M 的视频')
          return false
        }
        this.uploadAll(files, 'video') // if (!files.name.split('?')[0].endsWith('.doc') && !files.name.split('?')[0].endsWith('.docx') && !files.name.split('?')[0].endsWith('.pdf') && !files.name.split('?')[0].endsWith('.zip') && !files.name.split('?')[0].endsWith('.rar')) {
        //   alert('上传类型仅支持doc、docx、pdf、zip、rar格式')
        //   // 清除不合适的文件，重置input的value
        //   this.value = null
        //   return false
        // }
        // var fileName = files.name
        // console.log(files, 'files')
        // document.getElementById('file-info').setAttribute('style', 'display:flex')
        // document.getElementById('fileName').textContent = fileName
      }
    },
    beforeFile (file) {
      if (file.type && 'image/png,image/jpg,image/jpeg,image/gif'.indexOf((file.type).toLowerCase) > -1) {
        Toast('请上传 png/jpg/jpeg/gif 格式图片')
        return false
      }
      if (file.size > 10 * 1024 * 1024) {
        Toast('请上传小于 10M 的图片')
        return false
      }
      return true
    },
    beforeVideo (file) {
      if (file.size > 300 * 1024 * 1024) {
        Toast('请上传小于 300M 的视频')
        return false
      }
      return true
    },
    deleteFile  (file, index) {
      const i = index
      this.image.splice(i.index, 1)
      this.realyImage.splice(i.index, 1)
    },
    deleteVideo (file, index) {
      const i = index
      this.video.splice(i.index, 1)
      this.realyVideo.splice(i.index, 1)
    },
    handleInput (e) {
      e.target.className = ''
    },

    handleUpload (file) {
      this.video = file
      this.uploadAll(file, 'video')
    },
    onVideoChange (e) {
      console.log(e, 'eeeeeeee')
      e.status = 'uploading'
      e.message = '上传中...'
      this.updateStatusVideo = e.file
      this.selectedFile = e.file
      this.uploadAll(this.selectedFile, 'video')
    },
    onVideoImageChange (e) {
      this.selectedFile = e.file
      this.uploadAll(this.selectedFile, 'videoImage')
    },
    errorList (name) {
      this.$refs[name].className = 'error'
    },
    async submit () {
      if (!this.contributor) {
        this.errorList('contributor')
        return false
      }
      if (!this.contact) {
        this.errorList('contact')
        return false
      }
      // if (!this.channelId) {
      //   this.errorList('channelId')
      //   return false
      // }
      if (!this.title) {
        this.errorList('title')
        return false
      }
      if (this.loading === true) {
        Toast('视频上传中，请完成后再提交')
        return false
      }
      if (this.radioValue !== 'video' && this.image.length === 0) {
        Toast('请上传图片')
        return false
      }
      this.ext = {
        telphone: this.telphone,
        channelId: this.channelId,
        channelValue: this.channelValue,
        link: this.link
      }
      console.log(this.video, 'tis.video')
      const obj = {
        activityId: this.activityId,
        manuscriptTypeId: this.manuscriptTypeId,
        categoryId: this.categoryId,
        title: this.title,
        contact: this.contact,
        contributor: this.contributor,
        image: this.realyImage,
        video: this.realyVideo,
        weight: this.weight,
        ext: JSON.stringify(this.ext)
      }
      const res = await savefile({
        obj
      })
      if (res.code === 0) {
        const message = this.radioValue === 'image' ? '图片投稿提交成功' : '视频投稿提交成功'
        const toast = Toast.success({
          duration: 0, // 持续展示 toast
          forbidClick: true,
          message: message
        })
        let second = 5
        const timer = setInterval(() => {
          second--
          if (second) {
            toast.message = message
          } else {
            clearInterval(timer)
            // 手动清除 Toast
            Toast.clear()
            this.$emit('onCancel', true)
          }
        }, 1000)
        // Toast(this.radioValue === 'image' ? '图片投稿保存成功' : '视频投稿保存成功')
        // setTimeout(() => {
        // }, 3000)
      }
      console.log(res, 'res')
      console.log(obj, 'obj')
    },
    onFileChange (e) {
      this.selectedFile = e.file
      this.uploadAll(this.selectedFile, 'image')
    },
    selectType (e) {
      this.video = []
      this.image = []
      this.realyImage = []
      this.realyVideo = []
      this.radioValue = e.name.indexOf('图片') > -1 ? 'image' : 'video'
      this.manuscriptTypeId = e.id
    },
    uploadAll (data, type) {
      const _this = this
      const formData = new FormData()
      formData.append('file', data)
      const xhr = new XMLHttpRequest()
      // eslint-disable-next-line camelcase
      const url = `${intfc_prefix_common}/api/collection/upload/file?keyword=123`
      xhr.open('POST', url)
      xhr.onreadystatechange = function () {
        if (xhr.readyState === 4 && xhr.status === 200) {
          console.log(xhr, 'xxxxxxxx')
          const res = xhr.response && JSON.parse(xhr.response)
          console.log(res, 'res')
          if (res.code === 0) {
            if (type === 'image') {
              _this.realyImage.push(res.data.fileUrl)
            } else if (type === 'video') {
              console.log(res.data, 'res,data')
              _this.realyVideo.push(res.data.mediaInfoId)
              console.log(_this.isMobileS, '_this.isMobileS')
              if (_this.isMobileS) {
                _this.loading = false
                _this.video.push(res.data)
                console.log(_this.video, 'this.video')
              } else {
                // eslint-disable-next-line array-callback-return
                _this.video && _this.video.map((item) => {
                  if (item.file.name === _this.updateStatusVideo.name) {
                    item.status = 'success'
                    item.message = '上传成功'
                    item.url = res.data.fileUrl
                  }
                })
              }
            }
          } else {
            _this.showTip = true
          }
        } else {
          console.log(xhr.readyState, xhr.status, 'xxxxxxxx')
          _this.waringInform = '您的作品上传失败'
          _this.loading = false
          // eslint-disable-next-line no-empty
          if (xhr.readyState === 4 && xhr.status === 0) {
          } else if (xhr.status !== 200) {
            if (type === 'video') {
              _this.video = _this.video.filter(item => item.status === 'success')
              console.log(_this.video, 'dddddd')
              // let index = 0
              // eslint-disable-next-line array-callback-return
              // _this.video && _this.video.map((item, idx) => {
              //   if (item.file.name === _this.updateStatusVideo.name) {
              //     index = idx - 1
              //     console.log(index, 'index')
              //   }
              // })
              // _this.video.splice(index, 1)
              _this.showTip = true
            }
          }
        }
      }
      xhr.send(formData)
    },
    checkChannel (index, type, data) {
      data.forEach((item) => {
        item.isChecked = false
      })
      type = data[index].value
      data[index].isChecked = true
    },
    goDown () {
      this.unfoldText = this.unfoldText === '展开' ? '收起' : '展开'
      this.isHideDescFlag = !this.isHideDescFlag
    }
  }
}
</script>
<style lang="less">
.van-overlay{
    background-color:rgba(0, 0, 0, 0.2) !important
}
.pc{
  .van-uploader{
    display: block;
  }
  .van-popup--center{
    background: #FDFEFE;
    box-shadow: 0px 0px 47px 12px rgba(18,39,120,0.16);
    border-radius: 10px;
    width: 40%;
    .icon{
        width:48px;
        height:48px;
    }
    h2{
      font-family: SourceHanSansCN, SourceHanSansCN;
      font-weight: bold;
      font-size: 26px;
      color: #333641;
      margin-bottom:25px;
    }
    p{
      font-family: SourceHanSansCN, SourceHanSansCN;
      font-weight: 500;
      font-size: 24px;
      margin-bottom:15px;
      color: #333641;
      line-height: 33px;
      padding-left:15px;
    }
    p::before{
      content:'';
      width: 8px;
      height: 8px;
      background: #0676ED;
      position:absolute;
      position: absolute;
      left: 0px;
      top: 13px;
      border-radius: 50%;
    }
    .btnModel{
      background: rgba(254,81,100,0.15);
      border-radius: 27px;
      border: 2px solid #FFFFFF;
      font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
      font-weight: 500;
      font-size: 28px;
      color: #FE5164;
      line-height: 28px;
      width: 180px;
      height: 54px;
      margin: 0 auto;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top:34px;
      cursor: pointer;
    }
  }
}
.van-popup--center{
    margin:0 auto;
    z-index: 2002;
    text-align: center;
    padding: 25px 35px;
    width: 92%;
    background: #FDFEFE;
    box-shadow: 0px 0px 31px 8px rgba(18,39,120,0.16);
    border-radius: 10px;
    .icon{
        width:32px;
        height:32px;
    }
    h2{
      font-family: SourceHanSansCN, SourceHanSansCN;
      font-weight: bold;
      font-size: 14px;
      color: #333641;
      margin-bottom:5px;
    }
    p{
      font-family: SourceHanSansCN, SourceHanSansCN;
      font-weight: 500;
      font-size: 14px;
      color: #333641;
      margin-bottom:5px;
      text-align: left;
      position: relative;
      padding-left: 10px;
      line-height: 22px;
    }
    p::before{
      content:'';
      width: 5px;
      height: 5px;
      background: #0676ED;
      position:absolute;
      position: absolute;
      left: 0px;
      top: 8px;
      border-radius: 50%;
    }
    .btnModel{
      background: rgba(254,81,100,0.15);
      border-radius: 15px;
      border: 1px solid #FFFFFF;
      font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
      font-weight: 500;
      font-size: 16px;
      color: #FE5164;
      width: 100px;
      height: 30px;
      margin: 0 auto;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top:20px;
    }
}
.pc{
  .van-icon-success:before{
    content: '';
  }
  .van-radio__icon--checked>.van-icon-success{
    background: url('@/assets/images/check.png') no-repeat;
    background-size: 100% 100%;
  }
}
</style>
<style scoped lang="less">
.pc{
  display: flex;
  padding:5px;
  .add-pcForm{
    padding:50px 20px 0 50px;
    background: #FDFEFE;
    box-shadow: 9px 6px 17px -9px rgba(27,58,146,0.16);
    border-radius: 15px 15px 30px 15px;
    position: relative;
    width:70%;
      .name{
        font-family: SourceHanSansCN, SourceHanSansCN;
        font-weight: bold;
        font-size: 26px;
        color: #333641;
        margin-right:58px;
      }
      label{
        padding-left:5px;
      }
      .radio-box{
        display: inline-block;
        position: relative;
        height: 25px;
        line-height: 25px;
        margin-right: 10px;
        font-weight: bold;
        font-size: 20px;
        cursor: pointer;
      }
      .radio {
        display: inline-block;
        width:18px;
        height: 19px;
        position: relative;
        bottom: 2px;
        vertical-align: middle;
        cursor: pointer;
        background: url('@/assets/images/pc-unCheck.png') no-repeat;
        background-size: 100% 100%;
      }
      .input-radio {
        display: inline-block;
        position: absolute;
        opacity: 0;
        width: 18px;
        height: 19px;
        cursor: pointer;
        left: 0px;
        outline: none;
        -webkit-appearance: none;
        font-weight: bold;
        font-size: 16px;
        color: #333641;
        line-height: 16px;
      }
      .on {
        background: url('@/assets/images/pc-check.png') no-repeat;
        background-size: 100% 100%;
        color:#0676ED;
      }
      .on>label{
          color:#0676ED;
      }
      .formItem{
        margin-bottom:30px;
        h3{
          font-weight: bold;
          font-size: 26px;
          color: #333641;
          margin-bottom:25px;
        }
        .item-box{
          display: flex;
        }
        input{
            width: 212px;
            height: 36px;
            background: #FDFEFE;
            border-radius: 4px;
            border: 2px solid rgba(6,118,237,0.5);
            font-weight: bold;
            font-size: 20px;
            color: #333641;
            line-height: 20px;
            font-family: SourceHanSansCN, SourceHanSansCN;
        }
        input::placeholder{
            font-family: SourceHanSansCN, SourceHanSansCN;
            font-weight: bold;
            font-size: 20px;
            color: #333641;
            line-height: 20px;
        }
        .input-box{
            display: flex;
            justify-content: flex-start;
            align-items: center;
            position: relative;
            margin-bottom: 30px;
        }
        .required{
            color:red;
            position: relative;
            top:5px;
        }
        .name-label{
            font-family: SourceHanSansCN, SourceHanSansCN;
            font-weight: 500;
            font-size: 20px;
            color: #333641;
            width: 140px;
            text-align: right;
            position: relative;
        }
        .name-label::before{
            content:"*";
            color:red;
            position: absolute;
            top:0;
            margin-left: -7px;
        }
        .other>.name-label::before{
            display: none;
        }
        .uploadList{
            max-width:410px;
            overflow-x:auto;
            -webkit-overflow-scrolling: touch;
            &::-webkit-scrollbar {
                display: none;
            }
        }
      }
      .nowidth>.name-label{
        width:unset;
      }
  }
  .pc-noice{
    width:30%;
    background: #DBEDFF;
    border-radius: 10px;
    margin-left:20px;
    display: flex;
    line-height: 38px;
    .addIcon{
      //width: 80px;
      height: 156px;
      background: #0676ED;
      border-radius: 17px 0px 17px 0px;
      font-family: SourceHanSansCN, SourceHanSansCN;
      font-weight: bold;
      font-size: 24px;
      color: #FFFFFF;
      line-height: 36px;
      text-align: center;
      font-style: normal;
      padding: 9px 10px 9px 10px;
    }
    img {
      width: 45px;
      height: 114px;
    }
    p{
      padding:50px 33px 40px 12px;
      font-size:22px;
      font-weight: 500;
    }
  }
  .submit{
      position: absolute;
      right: -10.5px;
      bottom: -13px;
      cursor: pointer;
      img{
          width:249px;
          height:108px;
      }
  }
}
.notice{
    background: #DBEDFF;
    border-radius: 10px;
    padding:14px 22px 19px 15px;
    margin-bottom:15px;
    margin-top:15px;
    .title{
        display: flex;
        justify-content: flex-start;
        align-items: center;
        position: relative;
    }
    .icon{
        width:24px;
        height:24px;
    }
    .notice-font{
        font-family: SourceHanSansCN, SourceHanSansCN;
        font-weight: bold;
        font-size: 18px;
        color: #333641;
        line-height: 18px;
        margin-left:7px;
    }
    .more{
        font-family: SourceHanSansCN, SourceHanSansCN;
        font-weight: 500;
        font-size: 12px;
        color: #0676ED;
        line-height: 12px;
        position: absolute;
        right: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        img{
            width:18px;
            height:18px;
        }
    }
    p{
        color:#333641;
        font-size:14px;
        line-height: 26px;
        font-family: SourceHanSansCN, SourceHanSansCN;
        font-weight: 500;
        margin-top:14px;
    }
}
.add-form{
    background: #FFFFFF;
    box-shadow: 9px 6px 17px -9px rgba(27,58,146,0.16);
    border-radius: 10px 10px 30px 10px;
    padding: 20px 15px 47px 15px;
    position: relative;
    .radio-box{
        display: inline-block;
        position: relative;
        height: 25px;
        line-height: 25px;
        margin-right: 5px;
        font-size: 16px;
    }
    .radio {
        display: inline-block;
        width:14px;
        height: 14px;
        vertical-align: middle;
        cursor: pointer;
        background: url('@/assets/images/unCheck.png') no-repeat;
        background-size: 100% 100%;
    }
    .input-radio {
        display: inline-block;
        position: absolute;
        opacity: 0;
        width: 14px;
        height: 14px;
        cursor: pointer;
        left: 0px;
        outline: none;
        -webkit-appearance: none;
        font-weight: bold;
        font-size: 16px;
        color: #333641;
        line-height: 16px;
    }
    .on {
        background: url('@/assets/images/check.png') no-repeat;
        background-size: 100% 100%;
        color:#0676ED;
    }
    .name{
        font-weight: bold;
        font-size: 18px;
        color: #333641;
        margin-right:30px;
    }
    label{
        padding-left:8px;
    }
    .formItem{
        margin-bottom:25px;
        h3{
        font-weight: bold;
        font-size: 18px;
        color: #333641;
        margin-bottom:12px;
        }
        input{
            max-width: 200px;
            height: 32px;
            background: #FDFEFE;
            border-radius: 4px;
            border: 1px solid #DAE1ED;
            font-weight: bold;
            font-size: 16px;
            color: #333641;
            line-height: 16px;
        }
        input::placeholder{
            font-weight: bold;
            font-size: 16px;
            color: #333641;
            line-height: 32px;
        }
        .input-box{
            display: flex;
            justify-content: flex-start;
            align-items: center;
            position: relative;
            margin-bottom: 12px;
        }
        .required{
            color:red;
            position: relative;
            top:5px;
        }
        .other>.name-label::before{
            display: none;
        }
        .name-label::before{
            content:"*";
            color:red;
            position: absolute;
            top:0;
            margin-left: -7px;
        }
        .name-label{
            font-weight: 500;
            font-size: 16px;
            color: #333641;
            line-height: 16px;
            width: 100px;
            text-align: right;
            position: relative;
        }
        .uploadList{
            max-width:210px;
            overflow-x:auto;
            -webkit-overflow-scrolling: touch;
            &::-webkit-scrollbar {
                display: none;
            }
        }
    }
    .submit{
        position: absolute;
        right: -9.5px;
        bottom: -19px;
        img{
            width:140px;
            height:60px;
        }
    }
}
.error{
  border:1px solid red !important;
}
.active{
  color:#0676ED;
}
.file-upload {
        position: relative;
        overflow: hidden;
        display: inline-block;
        width:100%;
    }
    .file-upload .upload-button {
        display: inline-block;
        background-color: #fff;
        color: #000;
        padding: 15px 17px;
        border: 1px solid #eab293;
        cursor: pointer;
        text-align: center;
        text-decoration: none;
        border-radius: 5px;
        font-size:14px;
    }
    .file-upload #file-info {
        display: block;
        vertical-align: middle;
        padding: 10px;
        //background-color: #f8f9fa;
        border-radius: 5px;
        font-size: 14px;
        color: #555;
        margin-top:10px;
    }
    .file-upload #file-info #deleteFile{
        margin-left: 20px;
        cursor: pointer;
    }
    .file-upload #file-info:hover {
        // background-color: #f1f1f1;
    }
    .file-item{
      display: flex;
      background-color: #f8f9fa;
    margin-bottom: 10px;
    }
    .fileName{
      width:80%;
      word-wrap: break-word;
    }
    .hint{
      font-size: 12px;
      color:#877e7e;
    }
</style>
